module.exports = "precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 position;\n\nuniform mat4 uModel;\nuniform mat4 uView;\nuniform mat4 uProjection;\n\nvoid main() {\n  // Determine position\n  gl_Position = uProjection * uView * uModel * position;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./~/glslify-loader!/Users/songseunggeun/voxeline/engine/shaders/focused.vert
 ** module id = 774
 ** module chunks = 0
 **/